export default "__VITE_ASSET__BPrwiO$R__"